import LineChart from "../Charts/LineChart";
import { t } from "i18next";
import { convertTimestamp } from "../../utils/convertTimestamp";

const getLevelValueFromSession = (session, levelsList) => {
  if (!session || !levelsList || !levelsList.length) return undefined;

  const rawLevel = session?.results?.recommendation?.levelId;

  if (rawLevel == null) return undefined;

  if (typeof rawLevel === "number") return rawLevel;

  const targetId =
    typeof rawLevel === "object" ? rawLevel.id || rawLevel._id : rawLevel;
  const targetCode = typeof rawLevel === "object" ? rawLevel.code : rawLevel;

  const foundLevel = levelsList.find((l) => {
    if (!l) return false;
    if (targetId && (l.id === targetId || l._id === targetId)) return true;
    if (targetCode && l.code === targetCode) return true;
    return false;
  });

  return foundLevel?.value;
};

const StudentProgressLevels = ({ sessionsList, levelsList }) => {
  const title = t("profile.advanceArabi");
  const tooltipName = t("profile.arabi21");

  const getLabelLevel = (value) => {
    const level = levelsList?.find((level) => level.value === value);
    return level?.code;
  };

  const data = sessionsList
    ?.map((session) => ({
      id: convertTimestamp(session?.createdAt),
      timestamp: new Date(session?.createdAt).getTime(),
      value: getLevelValueFromSession(session, levelsList),
    }))
    .filter((item) => item.value !== undefined)
    .sort((a, b) => a.timestamp - b.timestamp);

  const style = {
    color: "#14b8a6",
    fontSize: "14px",
    fontWeight: "bold",
  };
  return (
    <LineChart
      title={title}
      getLabel={getLabelLevel}
      tooltipName={tooltipName}
      data={data}
      style={style}
    />
  );
};
export default StudentProgressLevels;
